module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch1.jpg",
      "width": "5%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("I guess I could start my story by telling you about the school assembly on Monday morning. It will give you a good idea of what has been happening to me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I pushed into the third row of the auditorium and dropped down beside my best friend, Bill Buzzner. (Everyone calls him Buzzy.) I had no idea that I was about to freak out and go totally wacko in front of the whole school.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My name is Sammy Baker. I’m twelve, and I never freak out or lose my cool or go berserk. I’m probably the quietest, nicest, most law-abiding, rule-following, do-good kid at Grover Cleveland Middle School. Ask anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Even Miss Flake, my teacher, says I am the least trouble of any of her students. She says that’s her highest compliment. Miss Flake says she would give me a gold star for attitude and a gold star for behavior. Except she doesn’t believe in giving gold stars.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Miss Flake is very funny. She is always cracking jokes. She even makes fun of Mr. Harkness, the principal. She croaks in a deep, booming voice and struts around with her eyes popped out until she almost looks like a big frog. Just like Mr. Harkness. It always makes us roar.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She tells everyone that she has been a Flake her whole life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I like a teacher with a good sense of humor—don’t you? I don’t even mind all the homework she gives us—at least two hours a night.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But today I wasn’t laughing. We were supposed to go on a field trip to a farm where they make maple syrup. I mean, where they tap the trees and collect the syrup in buckets. Then we were all supposed to get a big pancake lunch with real maple syrup.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the trip had to be canceled because Mr. Harkness decided to invite Mayor Springfield to school for an assembly about city government.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("City government? Big whoop, right?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No field trip. No pancakes. And a boring lecture.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As we took our seats in the auditorium, I wanted to complain to Buzzy about how unfair it was. But he was talking to Summer Magee, who sat on his other side.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I couldn’t blame him for ignoring me. Summer is one of the hottest girls in school. I’ve had a mad crush on her since third grade, when we built a volcano together for the science fair.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Summer saved my life when the volcano exploded and a wave of burning hot lava gushed onto the front of my T-shirt. She grabbed the shirt in both hands—and ripped it off my body before I was too badly burned. The class went wild.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’ve had a thing for her ever since.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But let’s face facts. In the past three years, Summer hasn’t paid much attention to me at all. I think maybe she was disappointed that our volcano was such a loser. Or maybe she doesn’t even remember the whole thing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Summer has wavy blond hair, dimples in both cheeks, sky-blue eyes, and an awesome smile. She is the star of the gymnastics team. She is small and light and amazing on the balance beam. And why am I going on and on about her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I guess because she was telling some kind of long story to Buzzy and ignoring me as usual.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The auditorium was nearly full. The roar of voices echoed off the dark walls as we waited for the presentation to begin. Mr. Harkness was already onstage with the mayor. They were both standing behind the podium with their arms crossed in front of them, wearing identical brown suits.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As I said, Mr. Harkness looks a lot like a very big frog. Mayor Springfield is tall and skinny and kind of hunched over and makes me think of a praying mantis. His glasses catch the light, so you can’t see his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I turned and saw my archenemy Rubin Rubino squeezing into my row. Rubin tripped over a kid’s shoes and bumped a girl sitting in the row in front of us. As he started to edge past me, he stomped down hard on my right sneaker.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pain shot up my foot and leg and I let out a shriek.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oops. Sorry,” Rubin said. He flashed me that grin with his two front teeth poking out, and his big black eyes laughing, always laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rubin loves to cause me pain. He’s big and he’s strong. He’s built like a wide-body truck. He has thick, clumpy black hair that sticks out all over his round, pudgy head and makes him look like a caveman.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rubin always appears to be laughing or grinning or smiling or chuckling. I don’t think I’ve ever seen a serious expression on his face. Even when he’s dishing out the hurts.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Why does he love to pick on me and make my life a world of pain?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well, last year, he was showing off in front of a group of high school girls, telling them how great he is on a skateboard. And I came along and accidentally tripped him. His board went flying, and he fell on his face on the sidewalk and got a bloody nose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The girls all thought it was a riot. And they laughed their heads off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That’s why he has been my archenemy ever since.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rubin mussed up my hair as he squeezed down the aisle. He dropped heavily into the seat next to Summer. He took Summer’s face in both of his big hands and turned her head so she was facing him and not Buzzy. Then Rubin started talking to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Buzzy had no choice. He turned to me. “What’s up, Sammy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I shrugged. “I’m just bummed that our field trip was canceled.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Buzzy frowned at me. “But you don’t like maple syrup.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know,” I said, “but I like getting out of school and just hanging out someplace.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Buzzy and I look a lot like brothers. We both have short, light-brown hair and brown eyes. We’re about the same size, average in every way, not too tall or short, not heavy or skinny.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If you describe Buzzy, you pretty much describe me. Except I’m quieter than he is. His parents call him Motor Mouth. He talks a lot and gets more excited about things than I do.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Buzzy is braver than me. I admit it. I try hard not to be a wimp. But lots of things creep me out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Buzzy had his eyes on the podium onstage. “We had to listen to Mayor Springfield talk in my old school,” he said. “Do you know what he invented?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I shook my head. “No. What did he invent?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He invented "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("boring")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We both laughed. The auditorium lights dimmed. Onstage, Mr. Harkness cleared his throat into the podium microphone. A deafening squeal from the loudspeakers made everyone scream.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry about that,” the principal croaked in his froggy voice. He cleared his throat again. “I’m proud to introduce our special guest this morning. As many of you know, Jonathan Springfield is the mayor of our town. And he has come to give you all a special inside look at how city government works.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Some kid near the back of the auditorium yawned really loud. That made a lot of kids laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mr. Harkness waited till everyone calmed down. “This is a special opportunity for us,” he said. “And I want you all to show Mayor Springfield our best Grover Cleveland Middle School behavior.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The loudspeaker squealed again. “Let’s all give the mayor a round of applause,” Mr. Harkness said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kids clapped and I heard some sarcastic cheers. I saw Katie Springfield, the mayor’s daughter, a seventh grader, sitting at the end of the first row. She had her head down and looked totally embarrassed. I felt bad for her. I mean, who wants their father to come to school?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The mayor pulled some papers from his jacket pocket. His speech. He lowered his skinny praying-mantis head toward the podium and began to read. He had a soft voice and spoke in a low drone. I could barely hear him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I waited, half-listening for about ten minutes. Then I jumped to my feet. Stepping over shoes, I began to push my way to the aisle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, Sammy. Sammy—where are you going?” Buzzy called to me in a loud whisper.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But I ignored him. I stepped into the aisle and began to walk toward the stage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You’ll probably be a little surprised by what I did. I know I was very surprised myself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You see, I climbed onstage and walked up beside the mayor. And then I did a wild, crazy tap dance in front of the whole school. And as I did my nutty tap dance, I flapped my arms in the air and crowed at the top of my lungs like a rooster.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I had to do it. I had no choice. I couldn’t help myself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Why?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It’s kind of a long, scary story….")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd320f8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545825467_ch001.vue
// module id = 69
// module chunks = 0